export const pt = {
  hero: {
    title: "Negocie <span>Mais Inteligente</span> com Phemex + METRADE",
    subtitle: "Estratégias de trading profissionais agora acessíveis a todos",
    startTrading: "Cadastre-se Gratuitamente",
    signUpForFree: "Cadastre-se Gratuitamente",
    learnMore: "Saiba Mais Sobre Phemex",
    poweredBy: "Com tecnologia de",
    socialProof: "Junte-se a mais de 40,000 traders"
  },
  promo: {
    signUp: "Inscreva-se hoje e obtenha",
    months: "3 MESES GRÁTIS",
    worth: "Valor de 3x29$ • Economize 87$",
    limitedTime: "Oferta por tempo limitado! Expira em breve"
  },
  whyMetrade: {
    title: "Por Que Escolher METRADE",
    subtitle: "O parceiro perfeito para sua jornada de trading no Phemex",
    reason1: {
      title: "Estratégias Verificadas",
      description: "Todas as estratégias premium têm históricos comprovados e são rigorosamente avaliadas"
    },
    reason2: {
      title: "Gestão de Risco",
      description: "Controles de risco avançados integrados em cada estratégia premium para proteger seu capital"
    },
    reason3: {
      title: "Qualidade Suíça",
      description: "Construído na Suíça com precisão, confiabilidade e segurança"
    },
    reason4: {
      title: "Integração Perfeita",
      description: "Siga a estratégia em sua conta Phemex sem necessidade de conhecimentos técnicos"
    },
    reason5: {
      title: "Transparência Total",
      description: "Acesse dados de desempenho em tempo real e histórico completo de trading"
    },
    reason6: {
      title: "Suporte Especializado",
      description: "Equipe dedicada de profissionais prontos para ajudá-lo"
    }
  },
  steps: {
    title: "Inicie Sua Jornada de Trading",
    subtitle: "Comece em três passos simples",
    step1: {
      title: "Cadastre-se gratuitamente",
      description: "Crie sua conta em segundos apenas com seu email"
    },
    step2: {
      title: "Selecione uma Estratégia",
      description: "Navegue por estratégias adaptadas especificamente para traders do Phemex"
    },
    step3: {
      title: "Conecte e Comece",
      description: "Selecione sua estratégia com nossa configuração guiada e comece a negociar"
    },
    joinText: "Junte-se a milhares de usuários bem-sucedidos no METRADE"
  },
  stats: {
    title: "Desempenho Comprovado",
    subtitle: "Nossa plataforma oferece resultados consistentes para traders em todo o mundo",
    activeUsers: "Usuários Ativos em mais de 100 países",
    tradingVolume: "Volume de Trading processado diariamente",
    successRate: "Taxa de satisfação das pesquisas",
    support: "Suporte Prioritário em vários idiomas"
  },
  features: {
    title: "METRADE Marketplace",
    subtitle: "Junte-se a milhares de usuários bem-sucedidos que transformaram sua experiência de trading",
    feature1: {
      title: "Estratégias Comprovadas",
      description: "Acesse estratégias de trading testadas em batalha com taxas de sucesso verificadas de até 95%"
    },
    feature2: {
      title: "Gestão de Risco",
      description: "Parâmetros de risco pré-definidos protegem seu capital durante a volatilidade do mercado"
    },
    feature3: {
      title: "Integração Fácil",
      description: "Conecte sua conta Phemex em menos de 2 minutos com configuração guiada"
    },
    feature4: {
      title: "Baseado em Dados",
      description: "Tome decisões informadas com análises de desempenho em tempo real"
    }
  },
  strategyShowcase: {
    title: "Estratégias de Melhor Desempenho",
    subtitle: "Descubra nossas estratégias de trading mais bem-sucedidas disponíveis no Phemex",
    viewAll: "Ver Todas as Estratégias",
    strategy1: {
      name: "Mestre do Momentum",
      description: "Captura tendências de mercado com pontos de entrada e saída precisos",
      roi: "+175% ROI em 2023",
      winRate: "76% Taxa de Vitória",
      riskLevel: "Risco Médio"
    },
    strategy2: {
      name: "Vantagem da Volatilidade",
      description: "Prospera em mercados voláteis com parâmetros de trading adaptativos",
      roi: "+205% ROI em 2023",
      winRate: "81% Taxa de Vitória",
      riskLevel: "Risco Médio-Alto"
    },
    strategy3: {
      name: "Crescimento Estável",
      description: "Abordagem conservadora focada em retornos consistentes",
      roi: "+90% ROI em 2023",
      winRate: "89% Taxa de Vitória",
      riskLevel: "Baixo Risco"
    },
    phemexCompatible: "Otimizado para Phemex"
  },
  testimonials: {
    title: "Histórias de Sucesso",
    subtitle: "Ouça traders que já estão se beneficiando de nossas estratégias",
    testimonial1: {
      quote: "Já experimentei várias plataformas de copy trading, mas a integração da METRADE com a Phemex é, de longe, a mais suave. Meus retornos aumentaram 43% desde que comecei.",
      author: "Michael T.",
      location: "Reino Unido",
      strategy: ""
    },
    testimonial2: {
      quote: "Como trader iniciante, eu estava perdendo dinheiro constantemente. Com as estratégias da METRADE no Phemex, finalmente estou vendo resultados positivos sem passar horas nos gráficos.",
      author: "Sarah K.",
      location: "Singapura",
      strategy: ""
    },
    testimonial3: {
      quote: "A transparência foi o que mais me impressionou. Posso ver exatamente como minhas estratégias estão funcionando e os controles de risco salvaram meu capital durante quedas recentes do mercado.",
      author: "Alex D.",
      location: "Alemanha",
      strategy: ""
    }
  },
  faq: {
    title: "Perguntas Frequentes",
    subtitle: "Encontre respostas para perguntas comuns sobre a integração METRADE e Phemex",
    question1: {
      question: "Como funciona a integração Phemex-METRADE?",
      answer: "Nossa plataforma se conecta à sua conta Phemex através de chaves API seguras com permissões apenas para trading. Uma vez conectada, as estratégias que você selecionar executarão automaticamente negociações em seu nome com base em parâmetros predefinidos."
    },
    question2: {
      question: "Qual é o capital mínimo necessário para começar?",
      answer: "O mínimo é 1800 USDT para uma Estratégia Gratuita. O mínimo de 2300 USDT é uma Estratégia Premium com Gerenciamento de Risco."
    },
    question3: {
      question: "Como posso monitorar e controlar meu risco?",
      answer: "Cada estratégia vem com configurações de gerenciamento de risco integradas que você pode revisar antes de ativar. Você pode definir limites máximos de drawdown, e nossa plataforma interromperá automaticamente o trading se esses limites forem atingidos."
    },
    question4: {
      question: "Posso personalizar as estratégias de trading?",
      answer: "Sim, usuários premium podem ajustar certos parâmetros de estratégias, incluindo tamanho da posição, número máximo de negociações simultâneas e níveis de tolerância ao risco. Nossos planos básicos oferecem estratégias pré-configuradas."
    },
    question5: {
      question: "O que acontece se eu quiser parar de usar uma estratégia?",
      answer: "Você pode pausar ou desconectar uma estratégia a qualquer momento com um único clique. Isso interromperá imediatamente quaisquer novas negociações, oferecendo opções para gerenciar posições abertas existentes."
    },
    question6: {
      question: "Existem taxas ocultas?",
      answer: "Não. Cobramos uma taxa de assinatura mensal transparente com base no plano escolhido. Não há comissões adicionais sobre lucros ou cobranças ocultas. Você paga apenas as taxas de trading padrão da Phemex."
    }
  },
  footer: {
    copyright: "Todos os direitos reservados."
  },
  languageSelector: {
    language: "Idioma"
  },
  cta: {
    title: "Pronto para transformar seu trading?",
    subtitle: "Comece com um teste gratuito de 3 meses hoje",
    buttonText: "Cadastre-se Gratuitamente",
    noCredit: "Não é necessário cartão de crédito para o teste gratuito"
  }
};
